import styled from 'styled-components';
import theme from 'src/theme';

export const LoginWrapper = styled.div`
    text-align: center;
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border-radius: 4px;
    padding: 10px 40px 40px 40px;
    width: 300px;
    h1 {
        font-weight: 200;
    }
    .contact-details {
        margin-top: 1rem;
        font-size: smaller;
    }
    p {
        font-size: 17px;
        line-height: 1.5;
    }
    button {
        display: block;
        width: 100%;
        margin: 0;
        background: ${theme.legacyColors.darkBlue};
        padding: 15px 30px;
        border-radius: 4px;
        border: 0;
        color: #fff;
        font-size: 15px;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height: 1.3;
    }
    button:hover {
        background: ${theme.colors.background.darkBlue};
    }
    button:focus-visible {
        outline: 3px solid ${theme.legacyColors.orange};
        outline-offset: 2px;
    }
    .login-option-divider + .login-option button {
        background: ${theme.colors.background.orange};
        color: ${theme.colors.text.warningDark};
    }
    .login-option-divider + .login-option button:hover {
        background: ${theme.colors.verification.status.warning};
    }
    .login-option-divider + .login-option button:focus-visible {
        outline-color: ${theme.colors.brand.darkBlue};
    }
    .login-option {
        margin-top: 20px;
    }
    .contact-details + .login-option {
        margin-top: 40px;
    }
    .option-description {
        display: block;
        margin-top: 4px;
        overflow-wrap: anywhere;
        white-space: normal;
        font-size: 13px;
    }
    .login-option-divider {
        border: 0;
        border-top: 1px solid ${theme.legacyColors.greyBorderColor};
        margin: 32px 0 0;
    }
`;
